export default function wrap(...args) {
  let child = args.pop() // The last argument should be the main content
  let Elem
  while ((Elem = args.pop()) != null)
    child = <Elem>{child}</Elem>
  return child
}
